"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@angular/material");
var router_1 = require("@angular/router");
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var document_search_configs_provider_1 = require("./service/document-search-configs.provider");
var form_resolution_service_1 = require("../../../../shared/services/api/form-resolution.service");
var DocumentsSearchWrapperComponent = /** @class */ (function () {
    function DocumentsSearchWrapperComponent(documentSearchConfigProvider, formResolutionService, kbService, activatedRoute) {
        var _this = this;
        this.documentSearchConfigProvider = documentSearchConfigProvider;
        this.formResolutionService = formResolutionService;
        this.kbService = kbService;
        this.activatedRoute = activatedRoute;
        this._minQuerySymbols = 4;
        this._searchDocumentsCount = 100;
        this._destroy$ = new Subject_1.Subject();
        this._configsLoaded = false;
        this._rootCategory = this.activatedRoute.snapshot.params.category;
        if (this._rootCategory) {
            this.documentSearchConfigProvider
                .getConfigurations(this._rootCategory)
                .pipe(operators_1.takeUntil(this._destroy$))
                .subscribe(function (config) {
                _this._additionalActionConfigs = config.additionalActionConfigs;
                _this._additionalDocumentMetaDataFilterConfigs = config.additionalDocumentMetaDataFilterConfigs;
                _this._additionalFilterConfigs = config.additionalFilterConfigs;
                _this._categoryRelationConfig = config.categoryRelationConfig;
                _this._hasPreviewOption = config.hasPreviewOption;
                _this._hasDownloadOption = config.hasDownloadOption;
                _this._subEntityFilterConfig = config.subEntityFilterConfig;
                _this._sortDocumentFields = config.sortDocumentFields;
                _this._minQuerySymbols = config.minQuerySymbols;
                _this._excludedCategories = config.excludedCategories;
                _this._searchDocumentsCount = config.searchDocumentsCount;
                _this._configsLoaded = true;
            });
        }
        else {
            console.warn('Category name should be present in url');
        }
    }
    DocumentsSearchWrapperComponent.prototype.onEntityClicked = function (data) {
        var _this = this;
        this.kbService.getInstanceMetaField(data.category).pipe(operators_1.switchMap(function (instanceMetaField) {
            return _this.formResolutionService.getEntityFormProperties(data.category, data.entity[instanceMetaField.getSystemName()], data.entity)
                .pipe(operators_1.tap(function (formProperties) {
                _this._categoryName = data.category;
                _this._entityId = data.entity[instanceMetaField.getSystemName()];
                _this._formId = formProperties.viewFormId;
                _this._formName = formProperties.viewFormName;
                _this.drawerContainer = { 'drawer': _this.drawer };
                _this.drawer.open();
            }));
        }), operators_1.takeUntil(this._destroy$)).subscribe();
    };
    DocumentsSearchWrapperComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "additionalFilterConfigs", {
        get: function () {
            return this._additionalFilterConfigs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "categoryRelationConfig", {
        get: function () {
            return this._categoryRelationConfig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "excludedCategories", {
        get: function () {
            return this._excludedCategories;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "rootCategory", {
        get: function () {
            return this._rootCategory;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "subEntityFilterConfig", {
        get: function () {
            return this._subEntityFilterConfig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "additionalActionConfigs", {
        get: function () {
            return this._additionalActionConfigs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "opened", {
        get: function () {
            return this._opened;
        },
        set: function (value) {
            this._opened = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "entityId", {
        get: function () {
            return this._entityId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "categoryName", {
        get: function () {
            return this._categoryName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "formName", {
        get: function () {
            return this._formName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "formId", {
        get: function () {
            return this._formId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "hasPreviewOption", {
        get: function () {
            return this._hasPreviewOption;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "hasDownloadOption", {
        get: function () {
            return this._hasDownloadOption;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "sortDocumentFields", {
        get: function () {
            return this._sortDocumentFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "minQuerySymbols", {
        get: function () {
            return this._minQuerySymbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "searchDocumentsCount", {
        get: function () {
            return this._searchDocumentsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "additionalDocumentMetaDataFilterConfigs", {
        get: function () {
            return this._additionalDocumentMetaDataFilterConfigs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchWrapperComponent.prototype, "configsLoaded", {
        get: function () {
            return this._configsLoaded;
        },
        set: function (value) {
            this._configsLoaded = value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.ViewChild('drawer'),
        __metadata("design:type", material_1.MatDrawer)
    ], DocumentsSearchWrapperComponent.prototype, "drawer", void 0);
    DocumentsSearchWrapperComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-documents-search-wrapper',
            styles: [require('./documents-search-wrapper.component.css')],
            template: require('./documents-search-wrapper.component.html')
        }),
        __metadata("design:paramtypes", [document_search_configs_provider_1.DocumentSearchConfigsProvider,
            form_resolution_service_1.FormResolutionService,
            idm_kb_service_client_js_1.KbService,
            router_1.ActivatedRoute])
    ], DocumentsSearchWrapperComponent);
    return DocumentsSearchWrapperComponent;
}());
exports.DocumentsSearchWrapperComponent = DocumentsSearchWrapperComponent;
//# sourceMappingURL=documents-search-wrapper.component.js.map